var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2360",
    "data-name": "Group 2360",
    transform: "translate(-800 -344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    transform: "translate(800 344)",
    fill: "none",
    stroke: "#2ec973",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1075",
    "data-name": "Group 1075",
    transform: "translate(811.5 356)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M175.305,176l-10.714,12.754-4.592-5.1",
    transform: "translate(-155.5 -170.5)",
    fill: "none",
    stroke: "#2ec973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferSuccessIcon);
export default __webpack_public_path__ + "static/media/transfer-success-icon.6ca4ae850ffcf3bc876ad1d44fef7bf0.svg";
export { ForwardRef as ReactComponent };